import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'
import Layout from '@/components/layout'

Vue.use(VueRouter)
const router = new VueRouter({
  linkActiveClass: 'link-active',
  strict: process.env.NODE_ENV !== 'production',
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: '/home',
      meta: {
        title: '首页',
      },
      children: [
        {
          path: '/home',
          name: 'home',
          component: () => import('@/page/Home.vue'),
        },
      ],
    },
    {
      path: '/freight',
      component: () => import('@/page/freight'),
      children: [
        { path: '', redirect: 'fcl' },
        {
          path: 'fcl',
          component: () => import('@/page/freight/list/fcl'),
        },
        {
          path: 'lcl',
          component: () => import('@/page/freight/list/lcl'),
        },
        {
          path: 'air',
          component: () => import('@/page/freight/list/air'),
        },
        {
          path: 'fcl/detail/:compCode?/:id/:scheduleId',
          name: 'fclDetail',
          props: true,
          component: () => import('@/page/freight/detail/fclDetail'),
        },
        {
          path: 'lcl/detail/:compCode?/:id/:scheduleId',
          name: 'lclDetail',
          props: true,
          component: () => import('@/page/freight/detail/lclDetail'),
        },
        {
          path: 'air/detail/:compCode?/:id/:scheduleId',
          name: 'airDetail',
          props: true,
          component: () => import('@/page/freight/detail/airDetail'),
        },
      ],
    },
    {
      path: '/enquiry',
      component: () => import('@/page/enquiry'),
      children: [
        { path: '', redirect: 'trailer' },
        {
          path: 'trailer',
          component: () => import('@/page/enquiry/list/trailer'),
        },
        {
          path: 'fcl',
          component: () => import('@/page/enquiry/list/fcl'),
        },
        {
          path: 'lcl',
          component: () => import('@/page/enquiry/list/lcl'),
        },
        {
          path: 'air',
          component: () => import('@/page/enquiry/list/air'),
        },
        {
          path: 'trailerDetail/:demandId?/:compCode?/:no',
          name: 'enquiryTrailerDetail',
          props: true,
          component: () => import('@/page/enquiry/detail/trailerDetail'),
        },
        {
          path: 'fclDetail/:demandId?/:compCode?/:no',
          name: 'enquiryFclDetail',
          props: true,
          component: () => import('@/page/enquiry/detail/fclDetail'),
        },
        {
          path: 'lclDetail/:demandId?/:compCode?/:no',
          name: 'enquiryLclDetail',
          props: true,
          component: () => import('@/page/enquiry/detail/lclDetail'),
        },
        {
          path: 'airDetail/:demandId?/:compCode?/:no',
          name: 'enquiryAirDetail',
          props: true,
          component: () => import('@/page/enquiry/detail/airDetail'),
        },
      ],
    },
    {
      path: '/supplier',
      component: () => import('@/page/supplier'),
    },
    {
      path: '/product',
      component: () => import('@/page/product'),
    },
    {
      path: '/vipPlan',
      component: () => import('@/page/vipPlan'),
    },
    {
      path: '/news',
      component: () => import('@/page/news'),
    },
    {
      path: '/about',
      component: () => import('@/page/about'),
      children: [
        { path: '', redirect: 'about' },
        {
          path: 'about',
          component: () => import('@/page/about/about'),
        },
        {
          path: 'agreement',
          component: () => import('@/page/about/agreement'),
        },
        {
          path: 'contact',
          component: () => import('@/page/about/contact'),
        },
        {
          path: 'message',
          component: () => import('@/page/about/message'),
        },
        {
          path: 'owner',
          component: () => import('@/page/about/owner'),
        },
        {
          path: 'privacy',
          component: () => import('@/page/about/privacy'),
        },
        {
          path: 'problem',
          component: () => import('@/page/about/statement'),
        },
        {
          path: 'statement',
          component: () => import('@/page/about/statement'),
        },
        {
          path: 'supplier',
          component: () => import('@/page/about/supplier'),
        },
      ],
    },
    {
      path: '/login',
      component: () => import('@/page/login/login'),
    },
    {
      path: '/forget',
      component: () => import('@/page/login/forget'),
    },
    {
      path: '/registerComp',
      component: () => import('@/page/login/registerComp'),
    },
    {
      path: '/registerPerson',
      component: () => import('@/page/login/registerPerson'),
    },
    {
      path: '/register',
      component: () => import('@/page/login/register'),
    },
    {
      path: '/company/:id',
      name: 'company',
      component: () => import('@/page/company/index'),
    },
    {
      path: '/fcl/booking/:compCode?/:id',
      name: 'fclBooking',
      props: true,
      component: () => import('@/page/order/fclbooking'),
    },
    {
      path: '/lcl/booking/:compCode?/:id',
      name: 'lclBooking',
      props: true,
      component: () => import('@/page/order/lclbooking'),
    },
    {
      path: '/air/booking/:compCode?/:id',
      name: 'airBooking',
      props: true,
      component: () => import('@/page/order/airbooking'),
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login ../page.
    if (!store.getters.islogin) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      })
    } else {
      next()
    }
  } else {
    next() // 确保一定要调用 next()
  }
})
export default router
